const searchButtons = document.querySelectorAll('[data-open-search-modal]');
const closeButton = document.querySelector('[data-close-search-modal]');
const isOnSearchPage = document.querySelector('.search-overlay') !== null;
const navigationBar = document.querySelector('.main-navigation');

function saveReferrer() {
    sessionStorage.setItem("search-referrer", window.location.href);
}

function getReferrer() {
    const ref = sessionStorage.getItem("search-referrer");
    return ref && ref !== window.location.href ? ref : "/";
}

searchButtons.forEach((btn) =>
    btn.addEventListener('click', function () {
        saveReferrer();
    })
);

if (isOnSearchPage) {
    const form = document.getElementById("search-form");
    const input = document.getElementById("search-query");

    if (navigationBar) {
        navigationBar.classList.add("search-opened");
    }

    if (form && input) {
        form.addEventListener("submit", function (e) {
            e.preventDefault();
            const q = encodeURIComponent(input.value);
            const params = new URLSearchParams(window.location.search);
            params.set("q", q);
            window.location.search = params.toString();
        });

        input.focus();
    }

    if (closeButton) {
        closeButton.addEventListener("click", function () {
            
            if (navigationBar) {
                navigationBar.classList.remove("search-opened");
            }

            const referrer = getReferrer();
            window.location.href = referrer;
        });
    }

    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
            const referrer = getReferrer();
            window.location.href = referrer;
        }
    });
}